import { formatDateTime } from './time'

// Общие функции страниц «Зоны»: «Кто где сейчас» и «Статистика заездов».

// Цвет бейджа по типу места (тона BaseBadge).
export const KIND_TONES = {
  loading: 'brand',
  unloading: 'violet',
  fuel: 'warning',
  repair: 'danger',
  base: 'neutral',
  checkpoint: 'info',
  waiting: 'warning',
  wash: 'info',
  rest: 'neutral',
  deviation: 'danger',
  shift: 'violet',
  zone: 'neutral'
}

export function kindTone(kind) {
  return KIND_TONES[kind] || 'neutral'
}

const pad = (n) => String(n).padStart(2, '0')

// 3725 -> «1 ч 02 мин», 125 -> «2 мин», 90000 -> «1 д 1 ч», null -> «—».
export function formatDuration(seconds) {
  if (seconds === null || seconds === undefined || isNaN(seconds)) return '—'
  const total = Math.max(0, Math.round(seconds))
  if (total < 60) return total === 0 ? '0 мин' : '< 1 мин'
  const minutes = Math.floor(total / 60)
  if (minutes < 60) return minutes + ' мин'
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return hours + ' ч ' + pad(minutes % 60) + ' мин'
  return Math.floor(hours / 24) + ' д ' + (hours % 24) + ' ч'
}

// Единый формат даты и времени на страницах «Зоны» — «07.10.2026 14:05», по Екатеринбургу (см. time.js).
export function formatTime(iso) {
  return formatDateTime(iso)
}

// Сколько прошло: «только что», «3 мин назад», «2 ч назад».
export function formatAgo(iso, now = new Date()) {
  if (!iso) return 'нет данных'
  const seconds = (now - new Date(iso)) / 1000
  if (isNaN(seconds)) return 'нет данных'
  if (seconds < 60) return 'только что'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return minutes + ' мин назад'
  const hours = Math.floor(minutes / 60)
  return hours < 24 ? hours + ' ч назад' : Math.floor(hours / 24) + ' д назад'
}

// Текст ошибки запроса: сообщение API, иначе сообщение axios.
export function errorText(err, fallback) {
  const data = err && err.response && err.response.data
  return (data && (data.error || data.message)) || (err && err.message) || fallback
}
